import moment from 'moment';
import { get, post } from '../utils/http';

export const fetchSbl = (id) => get('FETCH_SBL', `/admin/lawdocuments/${id}`);

export const fetchRegisters = () => get('FETCH_REGISTERS', '/law/registers/flat');

export const updateLegalCommentDates = (id) => {
	let form = new FormData();
	form.append('id', id);
	return post(
		'SBL_UPDATE_LEGAL_COMMENT_DATES',
		`/admin/lawdocuments/updatelegalcommentdates`,
		form
	);
};

export const deleteAttachment = (id) => {
	let form = new FormData();
	form.append('id', id);
	return post('SBL_DELETE_ATTACHMENT', `/admin/lawdocuments/attachments/delete`, form);
};

export const edit = (attr, value) => ({ type: 'EDIT_SBL', payload: { attr, value } });

export const deleteLawDocument = (id) => {
	let form = new FormData();
	form.append('id', id);
	return post('SBL_DELETE', `/admin/lawdocuments/delete`, form);
};

export const onChangeTab = (activeKey) => ({ type: 'SBL_CHANGE_TAB', payload: activeKey });

export const save = ({
	id,
	title,
	content,
	register,
	databases,
	introductionDate,
	publicationDate,
	abbreviation,
	sfsNumber,
	originalFileName,
	preparation,
	published,
	externalWeblink,
	summary,
}) => {
	let form = new FormData();
	form.append('id', id);
	form.append('title', title);
	form.append('content', content);
	form.append('register', register);
	form.append('databases', databases);
	form.append('introductionDate', moment(introductionDate).format('YYYY-MM-DD'));
	form.append('publicationDate', moment(publicationDate).format('YYYY-MM-DD'));
	form.append('abbreviation', abbreviation);
	form.append('sfsNumber', sfsNumber);
	form.append('originalFileName', originalFileName);
	form.append('preparation', preparation);
	form.append('published', published);
	form.append('externalWeblink', externalWeblink);
	form.append('summary', summary);

	return post('SBL_SAVE', `/admin/lawdocuments/update`, form);
};

export const hideEmailDialog = () => ({ type: 'SBL_HIDE_EMAIL_DIALOG' });

export const showEmailDialog = (ids, emails, lastChanged, subject, content) => ({
	type: 'SBL_SHOW_EMAIL_DIALOG',
	payload: { ids, emails, lastChanged, subject, content },
});

export const submitEmailNotification = (ids, emails, lastChanged, subject, content) => {
	let form = new FormData();
	form.append('ids', ids);
	form.append('emails', emails);
	form.append('lastChanged', lastChanged);
	form.append('subject', subject);
	form.append('content', content);

	return post('SBL_SUBMIT_EMAIL_NOTIFICATION', `/admin/lawdocuments/email`, form);
};

export const changeWatchlistInput = (attr, value) => ({
	type: 'SBL_CHANGE_WATCHLIST_INPUT',
	payload: { attr, value },
});



// WEBPACK FOOTER //
// ./src/sbl/sblActions.js